import {dropdown} from "./utils/dropdown";
import { submitFiltersScroll } from "./utils/submitFilters";

const initFilters = () => {
    const filtersWrapper: HTMLElement | null = document.querySelector(
        ".block .block__filters"
    );

    if (!filtersWrapper) return;

    const filters: HTMLElement[] = Array.from(
        filtersWrapper.querySelectorAll(".dropdown")
    );

    filters.map((filter: HTMLElement) => dropdown(filter, filtersWrapper));

    submitFiltersScroll(filtersWrapper)
};

initFilters();
